<template>
  <div class="qmyx-container invite-client-bg-img">
    <div class="invite-content">
      <div class="invite-content-item">
        您的好友<span class="font-36">{{ inviterName }}</span>
      </div>
      <div class="invite-content-item">邀请您一起</div>
      <div class="invite-content-item font-36">
        扫码推荐购房 跟着华发赚“百万”
      </div>
      <div class="invite-content-item">邀请二维码：{{ inviteQRCodeNum }}</div>
      <div class="invite-content-item">
        <img :src="inviteQRCodeUrl" class="invite-qrcode" alt="" />
      </div>
      <div class="invite-content-item">长按识别二维码</div>
    </div>
    <img
      src="https://assets.rurushishi.com/yq-rs-make/huafa/img/fazhanjjr_img_bg_bottom.png"
      class="curve-border"
      alt=""
    />
    <div class="inviter-content">
      <div class="inviter-info">
        <div class="inviter-info-content">
          <div class="inviter-name" v-if="!isShare">{{ inviterName }}</div>
        </div>
      </div>
      <div class="inviter-count" @click="toInviterDetail">
        <div class="inviter-count-context" v-if="!isShare">
          <span class="inviter-count-tag">已发展经纪人</span>
          <span class="inviter-count-font-24">{{ invitedCount }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { getUserByTelOrIntroAgent } from "./api";
import { getAgent } from "../api";
import Cookie from "js-cookie";
import util from "@/utils/utils";
import utils from "../utils";
export default {
  data() {
    return {
      inviterName: "",
      inviterType: "",
      invitedCount: 0,
      inviteQRCodeNum: "",
      inviteQRCodeUrl: "",
      isShare: false
    };
  },
  computed: {
    ...mapState("qmyx", ["agentId", "agentTel"]),
    ...mapState([
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo"
    ])
  },
  methods: {
    ...mapMutations("qmyx", [
      "saveInvitedAgentList",
      "saveAgentId",
      "saveAgentTel"
    ]),
    toInviterDetail() {
      this.$router.push({
        name: "inviter-detail"
      });
    },
    initWxShare() {
      let shareDes = `您的好友${this.inviterName}邀请您一起扫码推荐购房，跟着华发年赚“百万”`;
      util
        .checkMapStateCallback(this, ["pageInfo", "shareSpreadInfo"])
        .then(() => {
          utils.setFoundShareInviteClientPage(
            "跟着华发年赚“百万”",
            shareDes,
            this.pageInfo,
            this.shareSpreadInfo,
            false,
            "",
            "https://assets.rurushishi.com/yq-rs-make/huafa/img/share_qmyx.jpg",
            "qmyx/invite-client",
            this.agentId,
            this.agentTel
          );
        });
    }
  },
  async activated() {
    let idAndPsn = JSON.parse(Cookie.get("t9_20200131_init"));
    let url = encodeURIComponent(
      `${location.origin}/h5/qmyx/check-agent?id=${idAndPsn.id}&psn=${idAndPsn.psn}`
    );
    this.isShare = this.$route.query.share ? true : false;
    if (this.$route.query.agentId && this.$route.query.agentTel) {
      let resp = await getUserByTelOrIntroAgent(
        this.$route.query.agentTel,
        this.$route.query.agentId,
        url
      );
      resp = resp.filter(item => {
        return item.agentTel === this.$route.query.agentTel;
      });
      this.inviterName = resp[0].agentName;
      this.inviteQRCodeUrl = resp[0].owxQrCode;
      this.inviteQRCodeNum = resp[0].agentTel;
    } else {
      let { status, agentLogin } = await getAgent();
      const statusMap = {
        "10": "全民经纪人",
        "30": "华发业主",
        "40": "华发员工",
        "50": "拓客团队"
      };
      this.inviterType = statusMap[status];
      this.inviterName = agentLogin.agentName;
      this.inviteQRCodeNum = agentLogin.agentTel;
      this.saveAgentId(agentLogin.id);
      this.saveAgentTel(agentLogin.agentTel);
      this.initWxShare();
      let resp = await getUserByTelOrIntroAgent(
        this.agentTel,
        this.agentId,
        url
      );
      let respSelf = resp.filter(item => {
        return item.agentTel == this.agentTel;
      });
      resp = resp.filter(item => {
        return item.agentTel !== this.agentTel;
      });

      console.log(respSelf);
      this.inviteQRCodeUrl = respSelf[0].owxQrCode;
      this.invitedCount = resp.length;
      this.saveInvitedAgentList(resp);
    }
  }
};
</script>
<style lang="scss" scoped>
.font-36 {
  font-size: 0.36rem;
}
.invite-client-bg-img {
  min-height: 100vh;
  background-image: url("https://assets.rurushishi.com/yq-rs-make/huafa/img/fazhanjjr_img_bg.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: 0 -3rem;
  display: flex;
  flex-direction: column;
  // overflow: hidden;
  & .invite-content {
    padding-top: 1.24rem;
    box-sizing: border-box;
    width: 100%;
    text-align: center;
    color: #ffffff;
    font-size: 0.28rem;
    opacity: 0.93;
    height: 10rem;
    & .invite-content-item {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: flex-end;
      & .invite-qrcode {
        width: 2.7rem;
        height: 2.7rem;
        background-color: #fff;
      }
      &:nth-child(1) {
        margin-bottom: 0.42rem;
      }
      &:nth-child(2) {
        margin-bottom: 0.44rem;
      }
      &:nth-child(3) {
        margin-bottom: 0.68rem;
      }
      &:nth-child(4) {
        margin-bottom: 0.66rem;
      }
      &:nth-child(5) {
        margin-bottom: 0.42rem;
      }
      &:nth-child(6) {
        margin-bottom: 1.92rem;
      }
    }
  }
  & .curve-border {
    display: block;
    width: 100%;
    height: 0.38rem;
  }
  & .inviter-content {
    width: 100%;
    flex: 1;
    min-height: 1.82rem;
    background-color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0rem 0.56rem;
    padding-top: 0.6rem;
    padding-bottom: 0.74rem;
    box-sizing: border-box;
    & .inviter-info {
      // height: 1.22rem;
      height: 0.68rem;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      & .inviter-info-content {
        height: 0.46rem;
        & .inviter-name {
          font-size: 0.32rem;
          color: #333;
          font-weight: 500;
        }
      }
    }
    & .inviter-count {
      display: flex;
      height: 0.68rem;
      flex-direction: column;
      justify-content: flex-end;
      & .inviter-count-context {
        height: 0.68rem;
        display: flex;
        flex-direction: row;
        align-items: baseline;
        & .inviter-count-tag {
          display: block;
          height: 0.4rem;
          font-size: 0.28rem;
          color: #999;
          line-height: 0.4rem;
        }
        & .inviter-count-font-24 {
          line-height: 0.68rem;
          height: 100%;
          display: block;
          font-size: 0.48rem;
          color: #333;
          margin-left: 0.24rem;
          position: relative;
          &::after {
            content: "";
            position: absolute;
            bottom: 0.16rem;
            right: -0.32rem;
            width: 0.24rem;
            height: 0.24rem;
            background-image: url("https://assets.rurushishi.com/yq-rs-make/huafa/img/common_ic_tiaozhuanxh.png");
            background-size: 100% auto;
            background-repeat: no-repeat;
          }
        }
      }
    }
  }
}
</style>
